var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "./RadioButton.css";
export const RadioButton = (_a) => {
    var { labelName, textColor = "#000000", fontSize = "", id, icon, checkIcon = false, bgColor = "#FFF", fontFamily, value, name, onChange, className = "", checked } = _a, props = __rest(_a, ["labelName", "textColor", "fontSize", "id", "icon", "checkIcon", "bgColor", "fontFamily", "value", "name", "onChange", "className", "checked"]);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "radiobutton-container" }, { children: [_jsx("input", { className: "radiobutton-input", type: "radio", id: id, name: name, value: value, checked: checked, onChange: onChange }), _jsx("label", { className: "radiobutton-label", htmlFor: id }), checkIcon ? _jsx("img", { className: "radiobutton-images", src: icon }) : _jsx(_Fragment, {}), _jsx("div", Object.assign({ className: "radiobutton-text" }, { children: _jsx("div", Object.assign({ style: {
                            fontSize: fontSize,
                            fontFamily: fontFamily,
                            color: textColor,
                            background: bgColor,
                        } }, { children: labelName })) }))] })) }));
};
